export const groupsFilterStyles = ({ COLORS }) => ({
  container: {
    marginBottom: '5px',
    '& button': {
      fontWeight: 'normal'
    }
  },
  groupsInfo: {
    listStyle: 'none',
    padding: '0',
    margin: '0',
    color: COLORS.TEXT.DARK_GREY.NORMAL,
    display: 'flex',
    alignItems: 'center',
    '& strong': {
      lineHeight: '2'
    },
    '& li': {
      paddingLeft: '24px',
      position: 'relative',
      '&:after': {
        content: '""',
        width: '4px',
        height: '4px',
        borderRadius: '4px',
        background: '#ddd',
        position: 'absolute',
        left: '10px',
        top: '12px'
      },
      '&:first-child': {
        padding: '0',
        '&:after': {
          display: 'none'
        }
      }
    }
  }
})

export const groupSelectorStyles = {
  content: {
    padding: '0',
    height: '366px'
  },
  pending: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%'
  }
}

export default {
  filters: {
    background: '#f8f8f8',
    padding: '25px 20px'
  },
  search: {
    display: 'flex',
    '& input': {
      borderRadius: '4px 0 0 4px',
      borderRight: 'none'
    },
    '& button': {
      height: '100%',
      borderRadius: '0 4px 4px 0',
      padding: '7px 14px'
    }
  },
  pupils: {
    height: '400px',
    overflow: 'auto',
    padding: '0 0 20px'
  },
  pending: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  table: {
    '& tr th': {
      display: 'none',
      '&:first-child': {
        paddingLeft: '20px',
        width: '44px',
        display: 'table-cell'
      },
      '&:last-child': {
        display: 'table-cell',
        width: '20px'
      },
      '@media (min-width: 451px)': {
        display: 'table-cell'
      }
    },
    '& tr td': {
      display: 'none',
      '&:first-child': {
        display: 'table-cell',
        paddingLeft: '20px'
      },
      '&:last-child': {
        display: 'table-cell',
        paddingRight: '20px'
      },
      '@media (min-width: 451px)': {
        display: 'table-cell'
      }
    }
  },
  yearHCell: {
    width: '90px'
  },
  permissionHCell: {
    width: '110px'
  },
  pupilName: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    fontSize: '32px',
    marginRight: '10px',
    flexShrink: '0'
  },
  uploadButton: {
    '& span': {
      display: 'none',
      '@media (min-width: 451px)': {
        display: 'inline'
      }
    },
    '& > div': {
      margin: '0 !important',
      '@media (min-width: 451px)': {
        margin: '0 6px 0 -2px !important'
      }
    }
  }
}
